<template>
    <div class="mt-3">
        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="contact-person">Contact person</label>
                <input type="text" placeholder="Contact person" class="form-control" name="contact-person" v-model="address.contact_person">
            </div>
            <div class="form-group col-md-6">
                <label for="vat-number">VAT</label>
                <input type="text" placeholder="VAT" class="form-control" name="vat-number" v-model="address.vat">
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="email">Email</label>
                <input type="email" class="form-control" name="email" v-model="address.email" placeholder="Email">
            </div>
            <div class="form-group col-md-6">
                <label for="telephone">Telephone</label>
                <input type="text" class="form-control" name="telephone" v-model="address.telephone" placeholder="Telephone">
            </div>
        </div>
        <div class="form-group">
            <label for="addr">Address</label>
            <input type="text" class="form-control" name="addr" v-model="address.address" placeholder="12 Test Street, City, Germany">
        </div>

        <button class="btn btn-danger" @click="lastStep">Go Back</button>
        <button type="submit" class="btn btn-danger" @click="nextStep">Continue</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            note: '',
        }
    },
    props: {
        address: {
            default: {
                title: '',
                address: '',
                vat: '',
                telephone: '',
                email: '',
                contact_person: '',
            },
            type: Object
        },
        cart: Object
    },
    methods: {
        nextStep: function(){
            this.$emit('step', 3);
        },
        lastStep: function(){
            this.$emit('step', 1);
        },
    },
    mounted() {
        axios.get('/api/user/address')
            .then(response => {
                var jres = response.data;
                console.log(response);

                if (jres != null) {
                    this.$emit('update:address', jres);
                } else {
                    console.log('User has no address set!');
                }
            })
            .catch(error => {
                console.log(error);
            });
    },
}
</script>

